<list-simple-filter
    *ngIf="showHeader$ | async"
    [searchText]="searchText$ | async"
    [placeholder]="'misc.Keywords'"
    [filters]="filters"
    [customFilter]="true"
    (mobileFilter)="openMobileFilter()"
>
    <div
        custom
        *ngIf="filtersFormConfig?.controls.length"
        class="filter-list display-mobile-none display-sm-none"
    >
        <div class="flexbox align-items-center job-list-filter-buttons">
            <ng-container *ngFor="let filter of filters.filters">
                <div
                    list-simple-filter-multiple-select
                    *ngIf="filter.type == 'multipleSelect'"
                    class="inline-flexbox simple-filters"
                    [filterData]="filter"
                    (changes)="applySimpleFilter($event)"
                >
                </div>
            </ng-container>

            <div
                dropdown
                *ngIf="displayMoreFilter"
                #moreFilter="bs-dropdown"
                class="btn-group more-filters-dropdown-group dropdown"
                autoClose="always"
                [insideClick]="true"
            >
                <button
                    dropdownToggle
                    id="cfEmployersAdvFiltersBtn"
                    class="btn btn_minimal filter-dropdown-btn more-filter-dropdown-btn no-caret"
                    type="button"
                    aria-controls="cfEmployersAdvFilters"
                >
                    <span class="filter-text">{{ 'misc.More filters' | translate }}</span>
                    <i class="icn-chevron_down"></i>
                </button>

                <div
                    *dropdownMenu
                    id="cfEmployersAdvFilters"
                    class="dropdown-menu more-filter-dropdown dropdown-menu-right"
                    role="form"
                    aria-labelledby="cfEmployersAdvFiltersBtn"
                >
                    <cf-more-filters
                        *ngIf="moreFilter.isOpen"
                        class="flexbox flex-column"
                        [filtersFormConfig]="filtersFormConfig"
                        [formValue]="params"
                        (onClear)="clearMultipleFilters()"
                        (onCancel)="closeMoreFiltersDropdown()"
                        (onApply)="applyMultipleFilters($event)"
                    >
                    </cf-more-filters>
                </div>
            </div>
        </div>
    </div>
</list-simple-filter>

<list-filter-chips
    class="border-top search-filter-chips"
    [selectedFilters]="selectedFilters"
    (clear)="clearFilter($event)"
>
</list-filter-chips>

<list-page
    resultString="event employers.resultString"
    [header]="showHeader$ | async"
    [displayPerPage]="(items$ | async)?.length"
    [items]="items$ | async"
    [page]="page$ | async"
    [perPage]="perPage$ | async"
    [totalCount]="totalCount$ | async"
    [displaySort]="false"
    [rowAnchor]="rowAnchor"
    [skeleton]="skeleton"
    [emptyState]="emptyState"
    (reload)="onReload($event)"
>
</list-page>
